/** Admin → Settings. Read-only on purpose: the staff account is changed in
 *  Identity Platform, and platform config stays absent rather than stubbed
 *  until GET/PUT /admin/config exists. */
import { AdminTopCrumb, useAdmin } from '../../adminShell';

export function AdminSettings() {
  const admin = useAdmin();

  return (
    <>
      <AdminTopCrumb>
        <b>Settings</b>
      </AdminTopCrumb>
      <main className="page" id="main">
        <div className="page__head">
          <div>
            <h1>Settings</h1>
            <p className="sub">Your staff account and how this console is secured</p>
          </div>
        </div>

        <div className="grid grid-2">
          <div className="panel">
            <div className="panel__head">
              <h2>Your staff account</h2>
            </div>
            <div className="panel__body">
              <table className="tbl">
                <tbody>
                  <tr>
                    <td className="dim">Name</td>
                    <td className="strong">{admin.name}</td>
                  </tr>
                  <tr>
                    <td className="dim">Email</td>
                    <td>{admin.email}</td>
                  </tr>
                  <tr>
                    <td className="dim">Admin ID</td>
                    <td className="dim">{admin.id}</td>
                  </tr>
                  <tr>
                    <td className="dim">Role</td>
                    <td>
                      <span className="tag tag--bad">Platform admin</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="panel__foot">Your password is held by Identity Platform. Tenpoint never stores one.</div>
          </div>

          <div className="panel">
            <div className="panel__head">
              <h2>How this console is secured</h2>
            </div>
            <div className="panel__body">
              <ul className="notes">
                <li>
                  <strong>Staff sessions are separate.</strong> They live in their own table with their own resolver, so a
                  customer’s cookie resolves to nothing here.
                </li>
                <li>
                  <strong>The database has its own lock.</strong> Every admin function re-checks you against{' '}
                  <code>platform_admins</code>, so a routing mistake in the API is not enough to reach a customer’s data.
                </li>
                <li>
                  <strong>Sessions idle out after 24 hours</strong> and only a SHA-256 of the cookie is stored, never the
                  cookie itself.
                </li>
                <li>
                  <strong>Every action is written to the customer’s own audit log</strong>, which is append-only by grant
                  rather than by convention.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
